import classNames from 'classnames';
import { PropsWithChildren, memo } from 'react';
import { useBackgroundScrollLock } from 'react-easyrocket';
import { useLocation } from 'react-router';
import { Sidebar } from './Sidebar';
import { useDrawer } from 'src/hooks/useDrawer';
import { twJoin } from 'tailwind-merge';

const _WrapperWithSidebar = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const { isLeftDrawerOpen, closeDrawer } = useDrawer();

  useBackgroundScrollLock(isLeftDrawerOpen, [isLeftDrawerOpen]);

  const isAccountLayout = location.pathname.includes('account');

  return (
    <>
      <aside
        className={twJoin(
          'w-[320px] max-w-full bg-bg_sidebar fixed bottom-0 h-full z-[700] flex flex-col justify-start items-center ease-in-out duration-300',
          isLeftDrawerOpen ? 'left-[0px]' : 'left-[-320px]'
        )}>
        <Sidebar />
      </aside>
      <main
        className={classNames(
          isAccountLayout && 'h-full',
          'w-full h-full ease-in-out duration-300 flex justify-center'
        )}>
        {children}
      </main>
      {isLeftDrawerOpen && (
        <div className="fixed top-0 left-0 w-full h-full z-[600] blured-bg" onClick={closeDrawer} />
      )}
    </>
  );
};

export const WrapperWithSidebar = memo(_WrapperWithSidebar);
